var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisa = function SvgVisa(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ECF0F1",
    fillRule: "evenodd",
    d: "M34 9.5H6c-1.1 0-2 .9-2 2v17c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2v-17c0-1.1-.9-2-2-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34495E",
    fillRule: "evenodd",
    d: "M34 9.5H6c-1.1 0-2 .9-2 2v2h32v-2c0-1.1-.9-2-2-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C40F",
    fillRule: "evenodd",
    d: "M4 26.5v2c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2v-2H4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34495E",
    fillRule: "evenodd",
    d: "M22.5 19.2c-.7-.4-1.1-.6-1.1-1 0-.3.4-.7 1.1-.7.6 0 1.1.1 1.5.3l.2.1.3-1.7c-.4-.2-1-.3-1.7-.3-1.9 0-3.3 1.1-3.3 2.6 0 1.1 1 1.7 1.7 2.1.8.4 1 .6 1 1 0 .5-.6.8-1.2.8-.8 0-1.2-.1-1.8-.4l-.3-.1-.3 1.7c.5.2 1.3.4 2.2.4 2 0 3.4-1 3.4-2.6 0-1-.5-1.7-1.7-2.2zm6.9-3.1h-1.5c-.5 0-.8.1-1 .6L24 23.8h2s.3-1 .4-1.2h2.5c.1.3.2 1.2.2 1.2H31l-1.6-7.7zm-2.4 5c.2-.4.8-2.2.8-2.2s.2-.4.3-.7l.1.7s.4 1.8.4 2.2H27zm-11.5 2.7h1.9l1.2-7.7h-1.9l-1.2 7.7zm-1.7-7.7l-1.9 5.3-.2-1.1c-.4-1.2-1.5-2.6-2.7-3.3l1.7 6.8h2.1l3.1-7.7h-2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C40F",
    fillRule: "evenodd",
    d: "M11 16.7c-.1-.5-.5-.6-.9-.7H7v.2c2.4.6 4.1 2.2 4.7 4.1l-.7-3.6z",
    clipRule: "evenodd"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visa.cfd391b9553d5c9374254ef9ef2924c0.svg";